import { render, staticRenderFns } from "./IncludedIcon.vue?vue&type=template&id=30cd11e6&scoped=true"
import script from "./IncludedIcon.vue?vue&type=script&lang=js"
export * from "./IncludedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cd11e6",
  null
  
)

export default component.exports